import React, {Component, ReactNode} from 'react'
import NatResidentUserSelectComponent
    from '../../../__NoAutomatedTests/components/common/resident/NatResidentUserSelectComponent'
import {SelectedUser} from '../../../__NoAutomatedTests/components/common/resident/NatResidentSelectedUser'
import NatRoomNumberRepo from '../../../__NoAutomatedTests/components/roomNumber/repository/NatRoomNumberRepo'
import NatRidgeRepo from '../../../__NoAutomatedTests/components/ridge/repository/NatRidgeRepo'
import EventEmitterExResident from '../../shared/pageBaseComponents/EventEmitterExResident'
import {ReserveFacilityModel} from '../ReserveFacilityModel'
import equal from 'fast-deep-equal'
import {DisplayItemDivider, DisplayItemInputTitleNoMargin} from '../../../styledComponents/DisplayItem'
import {
    BlockSpacer,
    BlockSpacerSpOnly,
    currentMedia,
    GridContainer,
    GridItem,
} from '../../../styledComponents/ResponsiveConvenience'
import {PlainLinkStyledButton, SecondaryButton} from '../../../styledComponents/Button'
import {StyledNote} from '../components/CommonStyle'
import styled from 'styled-components'
import {FlexContainer, LeftRowFlexContainer} from '../../../styledComponents/FlexComponents'
import {Colors} from '../../../styledComponents/Constants'
import {Messages} from '../../../Messages'
import {HKConstants} from '../../../HKConstants'
import {convertToRoomNumberForResident} from '../../../__NoAutomatedTests/common/util/Natutil'
import {Nullable} from '../../../app/TypeHelpers'
import moment from 'moment'
import {ACCESS_CONTROL_MANAGER} from '../../../CodeMaster'
import {NavigateFunction} from 'react-router-dom'

interface Props {
    sharedUseRoomNumberList: SelectedUser[]
    roomNumberRepo: NatRoomNumberRepo
    ridgeRepo: NatRidgeRepo
    eventEmitter: EventEmitterExResident
    reservationModel: ReserveFacilityModel
    navigate: NavigateFunction
    validPeriodCriteriaDate: Nullable<moment.Moment>
    accessControlManager: Nullable<ACCESS_CONTROL_MANAGER>
}

interface State {
    open: boolean
    sharedUseRoomNumberList: SelectedUser[]
}

class RRFFReserveUsersRoomNumberInput extends Component<Props, State> {

    constructor(props: Readonly<Props>) {
        super(props)

        this.state = {
            open: false,
            sharedUseRoomNumberList: props.sharedUseRoomNumberList,
        }

        this.handleAddButtonClick = this.handleAddButtonClick.bind(this)
        this.handleCancel = this.handleCancel.bind(this)
        this.handleUpdateSelectedUsers = this.handleUpdateSelectedUsers.bind(this)
    }

    componentDidMount(): void {
        this.props.reservationModel.withSelectedUserList(this.state.sharedUseRoomNumberList)
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
        if (!equal(prevProps.sharedUseRoomNumberList, this.props.sharedUseRoomNumberList)) {
            this.setState({sharedUseRoomNumberList: this.props.sharedUseRoomNumberList}, () => {
                this.props.reservationModel.withSelectedUserList(this.state.sharedUseRoomNumberList)
            })
        }
    }

    handleCancel(): void {
        this.setState({open: false})
    }

    handleUpdateSelectedUsers(sharedUseRoomNumberList: SelectedUser[]): void {
        this.setState({
            open: false,
            sharedUseRoomNumberList: sharedUseRoomNumberList,
        }, () => {
            this.props.reservationModel.withSelectedUserList(this.state.sharedUseRoomNumberList)
        })
    }

    handleAddButtonClick(): void {
        this.setState({open: true})
    }

    deleteLinkClick = (cardKeyUser: SelectedUser) => (_: React.MouseEvent<HTMLElement>) => {
        this.setState((prevState) => {
            return {
                sharedUseRoomNumberList: prevState.sharedUseRoomNumberList.filter(user => {
                    return user.ridgeCd !== cardKeyUser.ridgeCd || user.roomNumber !== cardKeyUser.roomNumber
                }),
            }
        }, () => {
            this.props.reservationModel.withSelectedUserList(this.state.sharedUseRoomNumberList)
        })
    }

    render(): ReactNode {
        const {roomNumberRepo, ridgeRepo, eventEmitter, navigate} = this.props
        const {sharedUseRoomNumberList} = this.state
        return (<>
            <BlockSpacer height={'30px'}/>
            <DisplayItemDivider/>
            <BlockSpacer height={'30px'}/>
            <GridContainer>
                <GridItem over={3}>
                    <DisplayItemInputTitleNoMargin>同時入室番号</DisplayItemInputTitleNoMargin>
                </GridItem>
                <GridItem over={9}>
                    <BlockSpacerSpOnly height={'10px'}/>
                    <AlignSwitchSecondaryButton onClick={this.handleAddButtonClick}>
                        設定する
                    </AlignSwitchSecondaryButton>
                </GridItem>

                <GridItem over={3}/>
                <GridItem over={9}>
                    {this.renderSharedUseRoomNumberList()}
                </GridItem>

                <GridItem over={3}/>
                <GridItem over={9}>
                    <StyledNote>
                        {Messages.IFACC0005.toString(HKConstants.CMN.OPC.MAX_SELECTABLE_SHARED_USE_ROOM_NUMBERS)}
                    </StyledNote>
                </GridItem>
            </GridContainer>
            <NatResidentUserSelectComponent
                open={this.state.open}
                onCancel={this.handleCancel}
                onUpdateSelectedUsers={this.handleUpdateSelectedUsers}
                selectedUserList={sharedUseRoomNumberList}
                maxSelectableKeyNumber={HKConstants.CMN.OPC.MAX_SELECTABLE_SHARED_USE_ROOM_NUMBERS}
                roomNumberRepo={roomNumberRepo}
                ridgeRepo={ridgeRepo}
                eventEmitter={eventEmitter}
                navigate={navigate}
                validPeriodCriteriaDate={this.props.validPeriodCriteriaDate}
                cardKeyNumberIsNotNullFlg={this.props.accessControlManager === ACCESS_CONTROL_MANAGER.ODEC_TECHNO}
            />
        </>)
    }

    private renderSharedUseRoomNumberList(): ReactNode {
        const {sharedUseRoomNumberList} = this.state
        if (sharedUseRoomNumberList.length === 0) {
            return null
        }
        return <>
            <BlockSpacer height={'15px'}/>
            {
                [...sharedUseRoomNumberList]
                    .sort((a, b) => {
                        const aName = `${a.ridgeCd}${a.roomNumber}`
                        const bName = `${b.ridgeCd}${b.roomNumber}`
                        if (aName === bName) {
                            return 0
                        }
                        return (aName > bName) ? 1 : -1
                    })
                    .map((item, index) => {
                        return <RidgeItem key={index}>
                            <FlexContainer>
                                <LeftRowFlexContainer>
                                    <BlockSpacer width={'15px'}/>
                                    <div>{item.ridgeName}</div>
                                    <BlockSpacer width={'15px'}/>
                                    <div>{convertToRoomNumberForResident(item.roomNumber)}</div>
                                </LeftRowFlexContainer>
                                <LeftRowFlexContainer>
                                    <PlainLinkStyledButton onClick={this.deleteLinkClick(item)}>
                                        削除
                                    </PlainLinkStyledButton>
                                    <BlockSpacer width={'15px'}/>
                                </LeftRowFlexContainer>
                            </FlexContainer>
                        </RidgeItem>
                    })
            }
        </>
    }
}

export default RRFFReserveUsersRoomNumberInput

const AlignSwitchSecondaryButton = styled(SecondaryButton)`
  ${currentMedia.greaterThan('pc')`
      margin-left: 0;
  `}
`

const RidgeItem = styled.div`
  margin: 15px 15px 0 0;
  padding-bottom: 15px;
  color: ${Colors.AccentDark};
  border-bottom: 1px solid ${Colors.Background};
`
